import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  percentOff: {
    defaultMessage: 'Save {percent}',
    description: 'Discount badge showing savings percentage',
    id: 'q49qTu',
  },
});
